import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { BlockBody, BlockContainer, BlockHeader } from '@medifind/containers';
import { IconCheckmark } from '@medifind/icons';
import { getDoctorInsurance } from '@medifind/interface';
import { isPrerender } from '@medifind/utils';
import MFLink from '../MFLink';
import { Skeleton } from '../utils';
import styles from './DoctorInsurance.module.scss';

const DoctorInsurance = ({ classes = {}, ...props }) => {
  const { personId, displayName, acceptsMedicare, demographics, showCarrierDetails, insurance: insuranceList = null } = props;
  const [insurance, setInsurance] = useState(null);
  const [toggleAll, setToggleAll] = useState(false);
  useEffect(() => {
    const setsetInsuranceEx = (list) => {
      if (acceptsMedicare) list?.unshift('Medicare');
      setInsurance(list);
    };
    if (personId && showCarrierDetails && !isPrerender) {
      setToggleAll(false);
      getDoctorInsurance(personId)
        .then((result) => setsetInsuranceEx(result))
        .catch(() => null);
    } else {
      setsetInsuranceEx(insuranceList);
    }
  }, [personId, showCarrierDetails, insuranceList, acceptsMedicare]);

  const listLength = toggleAll ? insurance.length + 1 : 6;
  const { sex } = demographics || {};
  return (
    <BlockContainer id="insurance" className={classNames(styles['insurances'], classes.block)}>
      <BlockHeader priority={props?.headerPriority} className={classes.blockHeader}>
        Insurance
      </BlockHeader>
      <BlockBody className={classes.blockBody}>
        {sex || !demographics ? (
          <>
            {sex ? (
              <p data-nosnippet style={{ fontWeight: 'normal' }}>
                Please contact the provider to confirm they accept your insurance or if you don't see your insurance listed.
              </p>
            ) : (
              <Skeleton count={5} />
            )}
          </>
        ) : null}

        {insurance && insurance.length > 0 ? (
          <>
            <p style={{ fontWeight: 'bold' }}>Accepted insurance plans</p>
            <ul className={styles['insurances__list']}>
              {insurance.slice(0, listLength).map((ins, i) => (
                <li key={i} className={styles['accepted']}>
                  <IconCheckmark />
                  &nbsp;{ins}
                </li>
              ))}
            </ul>
            {insurance.length - 6 > 0 && (
              <div style={{ textAlign: 'center' }}>
                <MFLink className={styles['link']} onClick={() => setToggleAll(!toggleAll)}>
                  View {insurance.length - 6} {toggleAll ? 'Less' : 'More'} Insurance
                  {insurance.length - 6 > 1 ? 's' : ''}{' '}
                  {toggleAll ? <span className={styles['plus']}>-</span> : <span className={styles['plus']}>+</span>}
                </MFLink>
              </div>
            )}
          </>
        ) : null}
      </BlockBody>
    </BlockContainer>
  );
};

export { DoctorInsurance as default, DoctorInsurance };
